module.exports = __webpack_public_path__ + "img/tumbnail1.3581aae9.png";